"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const fa_1 = require("react-icons/fa");
const style_1 = require("./style");
const IconButton_1 = __importDefault(require("../IconButton"));
function ToggableInput({ value, onChange, handleSetValue, required, isValid, helperText, defaultValue, handleToggle, }) {
    const [isToggled, setToggle] = react_1.default.useState(false);
    const onToggle = react_1.default.useCallback(() => {
        setToggle(!isToggled);
        if (handleToggle) {
            handleToggle();
        }
    }, [isToggled, handleToggle]);
    const onBlur = react_1.default.useCallback(() => {
        if (value === "") {
            return;
        }
        onToggle();
    }, [value]);
    const onSetValue = (event) => {
        if (!isValid) {
            return;
        }
        if (event.code === "Enter") {
            setToggle(false);
            if (handleSetValue) {
                handleSetValue(event);
            }
        }
    };
    return !isToggled ? (react_1.default.createElement(style_1.ValueWrapper, null,
        react_1.default.createElement(style_1.UntoggledValue, { variant: "h1", onClick: onToggle }, value),
        " ",
        react_1.default.createElement(IconButton_1.default, { icon: fa_1.FaRegEdit, onClick: onToggle }))) : (react_1.default.createElement(style_1.StyledToggledInput, { onBlur: onBlur, error: !isValid, defaultValue: defaultValue, required: required, value: value, helperText: helperText, onChange: onChange, onKeyDown: onSetValue }));
}
exports.default = ToggableInput;
